import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import { useActionless, useAppSelector } from 'redux/hooks'

import AnimatedHamburger from 'components/misc/AnimatedHamburger'

import styles from './mobileNavbarOptions.module.scss'

type Props = {
  className?: string
}

const MobileNavbarOptions = ({ className }: Props) => {
  const navigrationDrawerOpen = useAppSelector(state => state.active.navigationDrawerOpen)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  return (
    <button
      className={`${styles.button} ${className}`}
      onClick={() => setActiveState({ navigationDrawerOpen: !navigrationDrawerOpen })}>
      <AnimatedHamburger open={navigrationDrawerOpen} className={styles.hamburgerColor} />
    </button>
  )
}

export default MobileNavbarOptions
